import React from 'react';

import { Tooltip } from 'primereact/tooltip';

import { Employee } from '../../types/interfaces';
import { markDeletedItems } from '../../utils/markDeletedItems';
import { TagsComponent } from '../TagsComponent';

interface AssignedExecutorsTagsProps {
  employees: Employee[];
  tagItems: any[];
  deletedMarkSource: Employee[];
  onDelete?: (tag: any) => void;
}

export const AssignedExecutorsTags: React.FC<AssignedExecutorsTagsProps> = ({
  employees,
  tagItems,
  deletedMarkSource,
  onDelete
}) => {
  return (
    <>
      <Tooltip target=".employee-tags-card" position="bottom" />
      <div
        className="employee-tags-card executor-tags-container task-card__employee-tags grid flex flex-column border-1 border-300"
        data-pr-tooltip="Назначенные на наряд Исполнители"
      >
        <div className="flex flex-column">
          <div className="grid flex justify-content-between align-items-center">
            <label
              className="task-card__label--narrow"
              htmlFor="priority"
            ></label>
            {employees?.length > 0 && (
              <div
                className="task-card__tags-scroll task-card__tags-scroll--padded"
                id="tags-scroll"
              >
                <TagsComponent
                  passedClassName="gap-2"
                  initialTagsItems={markDeletedItems(tagItems, deletedMarkSource)}
                  onDelete={onDelete}
                />
              </div>
            )}
            {employees?.length < 1 && (
              <div className="task-card__tags-scroll" id="tags-scroll">
                Исполнители не выбраны
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignedExecutorsTags;
